import IconSocialMediaTiktok from './IconSocialMediaTiktok';

export default IconSocialMediaTiktok;
